import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { OffreEmploiService } from '../../services/offreEmploi.service';

@Injectable()
export class OffreEmploiResolver implements Resolve<Observable<string>> {

  constructor(
    private offreEmploiService: OffreEmploiService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    const id_offre_emploi = route.params.id_offre_emploi;
    return this.offreEmploiService.getOne(id_offre_emploi).pipe(map(
      (res) => {
        return JSON.stringify(res);
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
